const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Get+Profile+API


function getPublicProfileByNickname(nickname) {
    let url = `/api/users/profiles/${nickname}?source=public`;
    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}

function getCurrentProfileEmailSubscriptionStatus() {
    let url = '/api/users/profiles/current?propertiesToInclude=emailSubscriptionInfo';
    return ufeApi.makeRequest(url, {
        method: 'GET'
    }).then(data => data.errorCode ? Promise.reject(data) :
        data.emailSubscriptionInfo &&
            data.emailSubscriptionInfo.subscriptionStatus === 'SUBSCRIBED');
}

function lookupProfileByLogin(email) {
    let url = '/api/users/profiles';
    return ufeApi.makeRequest(url, {
        method: 'PUT',
        body: JSON.stringify({
            email,
            source: 'lookup'
        })
    }).then(data => data.profileId ? data : Promise.reject());
}

function getProfileForPasswordReset(email) {
    let url = '/api/users/profiles';
    return ufeApi.makeRequest(url, {
        method: 'PUT',
        body: JSON.stringify({
            email,
            source: 'resetPassword'
        })
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = {
    getPublicProfileByNickname,
    getCurrentProfileEmailSubscriptionStatus,
    lookupProfileByLogin,
    getProfileForPasswordReset
};
